<template>
    <v-col class="pr-0">
        <v-row no-gutters style="z-index: 1; position: relative">
            <v-col>
                <!-- regular toolbar -->
                <div
                    class="d-flex align-center"
                >
                    <div
                        v-if="$vuetify.breakpoint.mdAndUp"
                        class="title font-weight-regular"
                    >
                        {{ richDataTableController.getTotalRows() }}
                        {{ $tc("client | clients", richDataTableController.getTotalRows()) }}
                    </div>
                    <div
                        v-else
                        :class="$vuetify.breakpoint.smAndDown ? 'body-2 neutral_n300--text' : ''"
                    >
                        <dropdown
                            :items="client_bookmarks"
                            :menu-props="{
                                'open-on-hover': false,
                                'offset-y': true
                            }"
                            :toggle-select="false"
                            :multi="false"
                            :close-on-content-click="true"
                            name-key="name"
                            value-key="link"
                            show-selected-first
                            @input="navigate_bookmark($event)"
                        >
                            <template v-slot="{ on }">
                                <v-btn
                                    class="pl-2"
                                    text
                                    color="neutral_n300"
                                    v-on="on"
                                >
                                    <span
                                        class="text-none mr-1"
                                        style="letter-spacing: 0.1px"
                                    >
                                        {{ richDataTableController.getTotalRows() }}
                                        {{ $tc("client | clients", richDataTableController.getTotalRows()) }}
                                    </span>
                                    <v-icon
                                        color="grey"
                                        right
                                    >
                                        mdi-menu-down
                                    </v-icon>
                                </v-btn>
                            </template>
                        </dropdown>
                    </div>
                    <v-spacer/>
                    <div
                        class="d-flex"
                    >
                        <action-button
                            v-if="canAddClient"
                            icon="PlusSquare"
                            @click="onAddNewClientClick"
                        >
                            {{ $t("Add client").toUpperCase() }}
                        </action-button>
                        <v-btn
                            v-if="$vuetify.breakpoint.smAndDown"
                            small
                            text
                            class="text-none body-2 neutral_n300--text"
                            style="pointer-events: initial; z-index: 5;"
                            @click="$emit('updateMobileShowFilterbar', !mobileShowFilterbar)"
                        >
                            {{ mobileShowFilterbar ? $t("Hide filters") : $t("Show filters") }}
                        </v-btn>
                        <ColumnController
                            dense
                            :headers="richDataTableController.getAllHeaders()"
                            :visible-headers="richDataTableController.getVisibleHeaders().map(x => x.value)"
                            @update_columns="
                                richDataTableController.setVisibleHeadersWithoutLoadData(
                                    $event,
                                    ['default_person_name', 'subclients', 'contract_count','active_contracts', 'groups_string','client_group_id_list'])
                            "
                        />
                        <action-menu
                            v-if="selectedAccount.type === 'company' && $vuetify.breakpoint.mdAndUp"
                            :items="actionItems"
                            @action="actionItems[$event].action()"
                        />
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import RichDataTable from "../../../components/RichDataTable/RichDataTable";
import BulkActionBar from "./ClientsListBulkActionBar";
import {computed} from "@vue/composition-api";
import {Router} from "../../../composables/Router";
import AppModule from "../../../store/modules/app";
import BookmarkModule from "../../../store/modules/bookmark";
import {$t} from "../../../i18n";
import ColumnController from "../../../components/ColumnController";
import RightsModule from "@/composables/use-rights";
import CompanySettingsHelper from '@/helpers/company/settings'
import {
    FEATURE_CLIENT_ADD,
    FEATURE_CLIENT_IMPORT,
    validateFeatureAllowed
} from "@/modules/subscription/allowed_features";
import AccountModule from "@/store/modules/account";

export default {
    name: "TableActions",
    components: {
        RichDataTable,
        BulkActionBar,
        ColumnController
    },
    props: {
        selectedAccount: {
            type: Object,
            required: true
        },
        richDataTableController: {
            type: Object,
            required: true
        },
        isSelectedAccountPaid: {
            type: Boolean,
            required: true
        },
        mobileShowFilterbar: {
            type: Boolean,
            required: true
        }
    },
    setup(props, ctx) {
        const router = Router()
        const {client_bookmarks} = BookmarkModule();
        const {showFeatureNotEnabled} = AppModule();
        const {can_edit_account} = RightsModule();
        const {available_accounts} = AccountModule();

        const canAddClient = computed(() => !ctx.root.$vuetify.breakpoint.smAndDown && (can_edit_account(props.selectedAccount.id) || !CompanySettingsHelper.isClientManagementDisabledForUsers(props.selectedAccount)))
        const navigate_bookmark = function (bookmarks) {
            let new_link = bookmarks[0].link.replace(/^\/app/, "");
            router.push({path: new_link}).catch(() => {
            });
        };
        const selected_account = computed(() => {
            return available_accounts.value.find(i => i.id === props.selectedAccount.id);
        })
        const onAddNewClientClick = () => {
            validateFeatureAllowed(FEATURE_CLIENT_ADD, props.selectedAccount)
            router.push({name: "client_new", params: {account_id: props.selectedAccount.id}});
        };

        const onImportClientsClick = () => {
            validateFeatureAllowed(FEATURE_CLIENT_IMPORT, selected_account.value)
            router.push({name: "import_selection", params: {account_id: props.selectedAccount.id}});
        };


        const onExportClientsClick = () => {
            const params = props.richDataTableController.urlAdapter.getFullQuery()
            window.open("/api/a/" + props.selectedAccount.id + "/client_export?" + params, "_top");
        };


        const onExportContactsClick = () => {
            const params = props.richDataTableController.urlAdapter.getFullQuery()
            window.open("/api/a/" + props.selectedAccount.id + "/contact_export?" + params, "_top");
        };

        const actionItems = computed(() => {
            let items = []

            if (canAddClient.value) {
                items.push({
                    text: $t('Import clients'),
                    action: onImportClientsClick
                })
            }

            items.push({
                text: $t('Export clients'),
                action: onExportClientsClick
            })

            items.push({
                text: $t('Export client contacts'),
                action: onExportContactsClick
            })

            return items
        })

        return {
            client_bookmarks,
            navigate_bookmark,
            canAddClient,
            actionItems,
            onAddNewClientClick,
        }
    }
}
</script>

<style scoped>

</style>